import {useEffect} from 'react';
import {useLocation} from 'react-router';
import {closeAll, closeToast} from '@heroui/react';

function dismissToastFromNode(node) {
    const toastRoot =
        node.closest?.('[role="alertdialog"]') ??
        node.closest?.('.rest-toast');

    if (!toastRoot) {
        return false;
    }

    const region = toastRoot.closest('.rest-toast-region');
    if (!region) {
        return false;
    }

    const toastKey =
        toastRoot.getAttribute('data-key') ??
        toastRoot.closest('[data-key]')?.getAttribute('data-key');

    if (toastKey) {
        closeToast(toastKey);
    } else {
        closeAll();
    }

    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

    return true;
}

export function ToastGuard() {
    const location = useLocation();

    useEffect(() => {
        closeAll();
    }, [location.pathname]);

    useEffect(() => {
        const handlePointerUp = (event) => {
            if (!(event.target instanceof Element)) {
                return;
            }

            dismissToastFromNode(event.target);
        };

        document.addEventListener('pointerup', handlePointerUp, true);

        return () => {
            document.removeEventListener('pointerup', handlePointerUp, true);
        };
    }, []);

    return null;
}
